// Central config — edit contact details here.
// Placeholders provided by client; replace with real values when ready.
// WhatsApp number from env (digits only, international format). Empty = disabled.
const WA_RAW = (process.env.REACT_APP_WHATSAPP_NUMBER || "").replace(/\D/g, "");
// All WhatsApp CTAs are shown ONLY when a valid number is configured.
export const WHATSAPP_ENABLED = /^\d{8,15}$/.test(WA_RAW);

// Replaces WhatsApp mentions in copy with neutral wording while no number is
// configured. When WHATSAPP_ENABLED becomes true, the original text is kept.
const _WA_MAP = [
  [/Preventivo gratuito su WhatsApp/gi, "Preventivo gratuito e senza impegno"],
  [/Scrivici su WhatsApp o compila il modulo online/gi, "Compila il modulo online"],
  [/Scrivici su WhatsApp o compila il modulo/gi, "Compila il modulo online"],
  [/Su WhatsApp o tramite il modulo online/gi, "Tramite il modulo online"],
  [/Su WhatsApp o usa il modulo online/gi, "Usa il modulo online"],
  [/Basta scriverci su WhatsApp/gi, "Compila il modulo online"],
  [/Su WhatsApp ci mostri/gi, "Ci mostri"],
  [/Contatto su WhatsApp/gi, "Come contattarci"],
  [/\s*su WhatsApp/gi, ""],
  [/\s*via WhatsApp/gi, ""],
  [/WhatsApp/gi, ""],
];

export function neutralizeWA(text) {
  if (WHATSAPP_ENABLED || typeof text !== "string") return text;
  let out = text;
  for (const [re, rep] of _WA_MAP) out = out.replace(re, rep);
  return out.replace(/\s+([.,;:!?])/g, "$1").replace(/\s{2,}/g, " ").trim();
}

export const CONTACT = {
  businessName: "Muratore Imbianchino Roma",
  brandMark: "Muratore Imbianchino",
  slogan: "Lavori edili, tinteggiature e rifacimento bagni a Roma",
  whatsappNumber: WA_RAW,
  whatsappDisplay: WA_RAW ? `+${WA_RAW}` : "",
  email: process.env.REACT_APP_CONTACT_EMAIL || "preventivi@esempio.it",
  // Phone is secondary on purpose — not the primary channel.
  phoneDisplay: process.env.REACT_APP_PHONE_DISPLAY || "",
  phoneNumber: (process.env.REACT_APP_PHONE_NUMBER || "").replace(/\D/g, ""),
  area: "Roma e provincia",
};

export const PHONE_ENABLED = Boolean(CONTACT.phoneNumber);

// Titolare del trattamento — used in Privacy & Cookie Policy pages.
export const LEGAL = {
  owner: "Paolo Ristuccia",
  taxIdLabel: "Codice Fiscale",
  taxId: "RSTPLA78B22I754A",
  address: "Via Palermo 41, 96018 Pachino (SR)",
  privacyEmail: process.env.REACT_APP_CONTACT_EMAIL || "muratoreroma24@gmail.com",
  updated: "giugno 2026",
};

export const defaultWhatsAppMessage =
  "Ciao! Vorrei richiedere un preventivo per un lavoro a Roma.";

export function waLink(message) {
  const text = encodeURIComponent(message || defaultWhatsAppMessage);
  return `https://wa.me/${CONTACT.whatsappNumber}?text=${text}`;
}

export function mailtoLink() {
  const subject = encodeURIComponent("Richiesta preventivo — Muratore Imbianchino Roma");
  const body = encodeURIComponent(
    "Ciao,\n\nvorrei un preventivo per il seguente lavoro:\n\n- Tipo di lavoro:\n- Zona di Roma:\n- Descrizione:\n\nGrazie."
  );
  return `mailto:${CONTACT.email}?subject=${subject}&body=${body}`;
}

// Detect lead source from URL params (Google Ads, Meta Ads, organic, direct)
export function detectProvenienza() {
  if (typeof window === "undefined") return "Diretto";
  const p = new URLSearchParams(window.location.search);
  const src = (p.get("utm_source") || "").toLowerCase();
  if (p.get("gclid") || src.includes("google")) return "Google Ads";
  if (p.get("fbclid") || src.includes("facebook") || src === "fb") return "Facebook";
  if (src.includes("instagram") || src === "ig") return "Instagram";
  if (document.referrer && !document.referrer.includes(window.location.host)) return "Organico";
  return "Diretto";
}


export const EMAIL_SUBJECT = "Richiesta preventivo – Muratore Imbianchino Roma";

// Normalize an Italian phone number to wa.me digits (adds +39 when needed).
export function normalizeItalianPhone(raw) {
  if (!raw) return null;
  let d = String(raw).trim().replace(/[^\d+]/g, "").replace(/^\+/, "");
  if (d.startsWith("00")) d = d.slice(2);
  d = d.replace(/\D/g, "");
  if (!d) return null;
  if (!(d.startsWith("39") && d.length >= 11 && d.length <= 13)) {
    d = "39" + d;
  }
  if (d.length < 11 || d.length > 14) return null;
  return d;
}

export function isValidEmail(e) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(e || "").trim());
}

export function waLinkTo(number, text) {
  return `https://wa.me/${number}?text=${encodeURIComponent(text || "")}`;
}

export function mailtoTo(email, subject, body) {
  return `mailto:${email}?subject=${encodeURIComponent(subject || "")}&body=${encodeURIComponent(body || "")}`;
}
